import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
    Container,
    Row,
    Button,
    Alert,
    Col,
    ButtonToolbar,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    UncontrolledTooltip,
} from "reactstrap";

import api from "../../../api/";
import apiFunctions from "../../../api/functions.js";
import auth from "../../../auth/auth";
import { getLugaresEntregaData, getCentrosCostoData, getPersonasData, getPlantasData } from "../../../api/calls.js";

import 'react-toastify/dist/ReactToastify.css';
import "./FormViandas.scss"

import ModalConfirmacion from "./ModalConfirmacion.js";

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";

import moment from "moment";

class FormViandas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            loading: false,

            fecha: moment(),
            // Datos del User Logeado
            user_nombre: null,
            user_apellido: null,

            plantasSelect: [],
            planta_id: null,

            lugaresEntregaSelect: [], // Para carga manual de los inputs AsyncSeeker
            lugarEntrega: null,
            lugar_entrega_otros: null,

            menudiario_id: null,

            centrosCostoSelect: [],

            pedidosViandasDetalle: [],
            settingsPedidosViandasDetalle: [], // Para poder reestablecer todas las opciones seleccionadas en ese pedido
            pvdSelectedRow: null,

            ar_entradas: [],
            ar_menusPrincipales: [],
            ar_guarniciones: [],
            ar_ensaladas: [],
            ar_bebidas: [],
            ar_complementos: [],
            ar_postres: [],
            
            observacion: "",

            // Detalle
            apellido: "",
            personasSelect: [],
            persona_id: null,
            centroCosto: null,

            ensaladaComoMenuPrincipal: false,
            isOpenModal: false,
            msjModal: "",

            errors: [],
        };
    }

    OPCION_LUGAR_ENTREGA_OTROS_ID = -1;

    OPCION_NADA_ID = null;
    OPCION_NADA_CODIGO = '000';

    GALVAN_NOMBRE = "galvan";

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) {
            return errors[field];
        } else {
            return null;
        }
    }

    onChangeField(field, value) {
        this.setState((prevState) => {
            let errors = prevState.errors;
            if (errors) {
                errors[field] = null;
            }
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    cargarPlantas = () => {
        getPlantasData().then((plantasData) => {
            this.setState({ plantasSelect: plantasData });
        });
    }

    cargarLugaresDeEntrega = () => {
        getLugaresEntregaData().then((lugaresEntregaData) => {
            const opcionOtros = { id: this.OPCION_LUGAR_ENTREGA_OTROS_ID, nombre: 'Otros' } // Misma forma que devuelve el select de areas
            const lugaresEntregaSelect = [opcionOtros, ...lugaresEntregaData]; // La opcion otros tiene que estar en primer lugar para mayor comodidad

            this.setState({ lugaresEntregaSelect: lugaresEntregaSelect });
        });
    }

    cargarCentrosCosto = () => {
        getCentrosCostoData().then((centrosCostoData) => {
            this.setState({ centrosCostoSelect: centrosCostoData });
        });
    }

    cargarDatosDelUsuario = () => {
        apiFunctions.get(
            api.personas.datosPersonasUsuarios,
            null,
            null,
            null,
            (response) => {
                let data = response.data;
                if (data) {
                    this.setState({
                        planta_id: data.planta ? data.planta.id : null,
                        lugarEntrega: data.area ? data.area.id : null,
                        user_nombre: data.nombre ? data.nombre : null,
                        user_apellido: data.apellido ? data.apellido : null,
                    });
                }
            }
        );
    }

    componentDidMount = () => {
        // (Nota) Las personas se cargan cuando se elige un menú diario (ver el handle),
        // dependen del menú. (Si ya pidieron para ese turno no aparecen en la lista)
        this.cargarPlantas();
        this.cargarLugaresDeEntrega();
        this.cargarCentrosCosto();
        this.cargarDatosDelUsuario();
    };

    /* ---------- FUNC. CARGAR MENUES ---------- */
    /**
     * Se formatean los datos recibidos para poder ser vistos en las tablas
     * @param {*} data - Datos de la api
     */
    cargarMenues = (data) => {
        const opcionNada = { id: this.OPCION_NADA_ID, codigo: this.OPCION_NADA_CODIGO, nombre: 'Nada', checked: false };

        if (data) {
            // Se agrega la opcion nada al principio de la lista para cuando el usuario no quiere nada de la tabla
            this.setState({
                ar_entradas: [opcionNada, ...data.entradas.map(entrada => ({ ...entrada, checked: false }))],
                ar_menusPrincipales: [opcionNada, ...data.menus_principales.map(menuPrincipal => ({ ...menuPrincipal, checked: false }))],
                ar_guarniciones: [opcionNada, ...data.guarniciones.map(guarnicion => ({ ...guarnicion, checked: false }))],
                ar_ensaladas: [opcionNada, ...data.ensaladas.map(ensalada => ({ ...ensalada, checked: false }))],
                ar_complementos: [opcionNada, ...data.complementos.map(complemento => ({ ...complemento, checked: false }))],
                ar_postres: [opcionNada, ...data.postres.map(e => ({ ...e, checked: false }))],
                ar_bebidas: [opcionNada, ...data.bebidas.map(bebida => ({ ...bebida, checked: false }))],
                ensaladaComoMenuPrincipal: false,
            });
        } else {
            this.setState({
                ar_entradas: [opcionNada],
                ar_menusPrincipales: [opcionNada],
                ar_guarniciones: [opcionNada],
                ar_ensaladas: [opcionNada],
                ar_complementos: [opcionNada],
                ar_postres: [opcionNada],
                ar_bebidas: [opcionNada],
            });
        }
    };

    checkEntradas = (i) => {
        const ar_entradas = this.state.ar_entradas.map((entrada, index) => ({
            ...entrada, checked: index === i ? !entrada.checked : false
        }));

        this.setState({ ar_entradas });
    };

    checkMenuPrincipal = (i) => {
        const ar_menusPrincipales = this.state.ar_menusPrincipales.map((menuPrincipal, index) => ({
            ...menuPrincipal, checked: index === i ? !menuPrincipal.checked : false
        }));

        this.setState({ ar_menusPrincipales });
    };

    checkGuarnicion = (i) => {
        const ar_guarniciones = this.state.ar_guarniciones.map((guarnicion, index) => ({
            ...guarnicion, checked: index === i ? !guarnicion.checked : false 
        }));

        this.setState({ ar_guarniciones });
    };

    checkComplemento = (index) => {
        this.setState((prevState) => {
            const selectedComplemento = prevState.ar_complementos[index];
            const newComplementos = prevState.ar_complementos.map((complemento, i) => {
                // Si se selecciona "Nada", desmarcar todo lo demás
                if (selectedComplemento.codigo === this.OPCION_NADA_CODIGO) {
                    return { ...complemento, checked: complemento.codigo === this.OPCION_NADA_CODIGO };
                }
                // Si se selecciona otro complemento, desmarcar "Nada" y alternar el complemento seleccionado
                if (complemento.codigo === this.OPCION_NADA_CODIGO) {
                    return { ...complemento, checked: false };
                }
                // se alterna el complemento seleccionado
                if (i === index) {
                    return { ...complemento, checked: !complemento.checked };
                }
                return complemento;
            });

            return { ar_complementos: newComplementos };
        });
    };

    /* ---------- CHECK ENSALADAS ---------- */
    checkEnsalada = (index) => {
        this.setState((prevState) => { 
            // Si se seleccionó ensalada como menu principal se permiten seleccionar 4 ensaladas max
            const maxSelectedCount = prevState.ensaladaComoMenuPrincipal ? 4 : 3;
            const selectedEnsalada = prevState.ar_ensaladas[index];
            const newEnsaladas = prevState.ar_ensaladas.map((ensalada, i) => {
                // Si seleccionamos "Nada", desmarcar todo lo demás
                if (selectedEnsalada.codigo === this.OPCION_NADA_CODIGO) {
                    return { ...ensalada, checked: ensalada.codigo === this.OPCION_NADA_CODIGO};
                }
                // Si seleccionamos otra ensalada, desmarcar "Nada"
                if (ensalada.codigo === this.OPCION_NADA_CODIGO) {
                    return { ...ensalada, checked: false };
                }
                // Alternar la ensalada seleccionada
                if (i === index) {
                    return { ...ensalada, checked: !ensalada.checked };
                }
                return ensalada;
            });

            // Contar cuántas ensaladas están seleccionadas
            const selectedCount = newEnsaladas.filter(e => e.checked).length;

            // Si la selección supera el límite, revertir la última selección
            if (selectedCount > maxSelectedCount) {
                newEnsaladas[index].checked = false; // Revertir la última selección
            }

            return { ar_ensaladas: newEnsaladas };
        });
    };

    /* ---------- CHECK POSTRE ---------- */
    checkPostre = (i) => {
        const ar_postres = this.state.ar_postres.map((postre, index) => ({
            ...postre, checked: index === i ? !postre.checked : false 
        }));

        this.setState({ ar_postres });
    };

    /* ---------- CHECK BEBIDAS ---------- */
    checkBebidas = (i) => {
        const ar_bebidas = this.state.ar_bebidas.map((bebida, index) => ({
            ...bebida, checked: index === i ? !bebida.checked : false
        }));

        this.setState({ ar_bebidas });
    };

    onValidation = () => {
        const { pedidosViandasDetalle } = this.state;
        let errors = {};
        let valid = true;

        if (pedidosViandasDetalle.length == 0) {
            errors["pedidosViandasDetalle"] = [
                { code: "blank", detail: "Cargue al menos un pedido" },
            ];
            valid = false;
        }
        this.setState({ errors: errors });
        return valid;
    };

    /**
     * Validacion de datos, seteando un error en caso de que no sea valido
     * @returns {boolean} - true si todos los datos son validos
     */
    onValidateDetalle = () => {
        const {
            persona_id,
        } = this.state;

        let errors = {};
        let valid = true;

        // Tiene que haber una persona cargada
        if (persona_id == null) {
            errors["persona_id"] = [
                { code: "blank", detail: "Ingrese un Apellido" },
            ];
            valid = false;
        }

        this.setState({ errors: errors });

        return valid;
    };

    /* ---------- FUNC. RESET OPCIONES ---------- */
    /**
     * Reset de todos los state a su valor por defecto excepto los state del modal de éxito para no cerrarlo.
     */
    resetForm = () => {
        // No es necesario resetear la data de los Select, por ejemplo, de 
        // lugaresEntregaSelect ni centrosCostoSelect son siempre las mismas 
        // opciones para los Select.
        // (Nota) personasSelect si se tiene que resetear porque no se puede
        // pedir un mismo menú dos veces (el endpoint los filtra).
        this.setState({
            disabled: false,
            loading: false,

            fecha: moment(),
            planta_id: null,

            lugarEntrega: null,
            lugar_entrega_otros: null,

            // Datos del User Logeado
            user_nombre: null,
            user_apellido: null,

            observacion: "",

            // Para forzar a seleccionar un menu diario y que se actualizer la
            // lista de personas que pueden pedir ese menu (ver el handle)
            menudiario_id: null,

            pedidosViandasDetalle: [],
            settingsPedidosViandasDetalle: [],
            pvdSelectedRow: null,

            ar_entradas: [],
            ar_menusPrincipales: [],
            ar_guarniciones: [],
            ar_ensaladas: [],
            ar_complementos: [],
            ar_postres: [],
            ar_bebidas: [],

            // Detalle
            apellido: "",
            personasSelect: [],
            persona_id: null,
            centroCosto: null,

            ensaladaComoMenuPrincipal: false,

            errors: [],
        });
    };

    agregarDetalle = () => {
        let pedidosViandasDetalle = [...this.state.pedidosViandasDetalle];
        let settingsPedidosViandasDetalle = [...this.state.settingsPedidosViandasDetalle];
        const {
            apellido,
            persona_id,
            centroCosto,

            ar_entradas,
            ar_menusPrincipales,
            ar_guarniciones,
            ar_ensaladas,
            ar_complementos,
            ar_postres,
            ar_bebidas,

            ensaladaComoMenuPrincipal,
        } = this.state;

        // Solo se puede seleccionar una entrada de la lista, por eso se busca solo una
        let checkedEntrada = ar_entradas.find(entrada => entrada.checked);
        let entradaId = checkedEntrada ? checkedEntrada.id : null;

        // Solo se puede seleccionar un menu principal de la lista, por eso se busca solo uno
        let checkedMenuPrincipal = ar_menusPrincipales.find(menuPrincipal => menuPrincipal.checked);
        let menuPrincipalId = checkedMenuPrincipal ? checkedMenuPrincipal.id : null;

        // En caso de que se seleccione la opcion "Nada" hay que dejar un array vacio para la api
        let checkedGuarnicion = ar_guarniciones.find(guarnicion => guarnicion.checked); // Solo se puede seleccionar una guarnicion de la lista, por eso se busca solo una
        let guarnicionId = checkedGuarnicion ? checkedGuarnicion.id : null;

        // En caso de que se seleccione la opcion "Nada" hay que dejar un array vacio para la api
        let ensaladasId = ar_ensaladas
        .filter(ensalada => ensalada.checked && ensalada.id !== this.OPCION_NADA_ID)
        .map(ensalada => ensalada.id);

        // En caso de que se seleccione la opcion "Nada" hay que dejar un array vacio para la api
        let complementosId = ar_complementos
            .filter(complemento => complemento.checked && complemento.id !== this.OPCION_NADA_ID)
            .map(complemento => complemento.id);

        // Solo se puede seleccionar un postre de la lista, por eso se busca solo uno
        let checkedPostre = ar_postres.find(postre => postre.checked); 
        let postreId = checkedPostre ? checkedPostre.id : null;

        // Solo se puede seleccionar una bebida de la lista, por eso se busca solo una
        let checkedBebida = ar_bebidas.find(bebida => bebida.checked);
        let bebidaId = checkedBebida ? checkedBebida.id : null;

        // Se verifica que esa persona no haya sido agregada anteriormente
        const existePersonaRepetida = pedidosViandasDetalle.find(pedido => pedido.persona_id == persona_id)
        if (!existePersonaRepetida) {
            if (this.onValidateDetalle()) {
                // Se agrega el pedido de la persona y se resetea el formulario
                // Algunos parametros se renombran para respetar el input de la api
                let detalle = {
                    apellido,
                    persona: persona_id,
                    dependencia: centroCosto,
                    entrada: entradaId,
                    menu_principal: menuPrincipalId,
                    guarnicion: guarnicionId,
                    ensaladas: ensaladasId,
                    complementos: complementosId, 
                    postre: postreId,
                    bebida: bebidaId,
                };

                let settings = {
                    ensaladaComoMenuPrincipal,
                }

                pedidosViandasDetalle.push(detalle);
                settingsPedidosViandasDetalle.push(settings);

                let errors = this.state.errors;
                errors["pedidosViandasDetalle"] = undefined;

                this.setState({
                    pedidosViandasDetalle: pedidosViandasDetalle,
                    settingsPedidosViandasDetalle: settingsPedidosViandasDetalle,
                    // Se Deselecciona a la persona y el centro de costo
                    persona_id: null,
                    centroCosto: null,

                    errors: errors,
                });

                this.resetCargaVianda();
            }
        } else {
            this.setState({
                errors: {
                    persona_id: [
                        {
                            code: "blank",
                            detail: "La persona ya fue ingresada",
                        },
                    ],
                },
            });
        }
    };

    resetCargaVianda = () => {
        const {
            ar_entradas,
            ar_menusPrincipales,
            ar_guarniciones,
            ar_ensaladas,
            ar_complementos,
            ar_postres,
            ar_bebidas,
        } = this.state;

        const uncheckAll = (array) => array.map(e => ({ ...e, checked: false }));

        this.setState({
            ar_entradas: uncheckAll(ar_entradas),
            ar_menusPrincipales: uncheckAll(ar_menusPrincipales),
            ar_guarniciones: uncheckAll(ar_guarniciones),
            ar_ensaladas: uncheckAll(ar_ensaladas),
            ensaladaComoMenuPrincipal: false,
            ar_complementos: uncheckAll(ar_complementos),
            ar_postres: uncheckAll(ar_postres),
            ar_bebidas: uncheckAll(ar_bebidas),
        });
    }

    /* ---------- FUNC. ELIMINAR PEDIDO ---------- */
    eliminarDetalle = () => {
        let pedidosViandasDetalle = [...this.state.pedidosViandasDetalle];
        let settingsPedidosViandasDetalle = [...this.state.settingsPedidosViandasDetalle];
        let pvdSelectedRow = this.state.pvdSelectedRow;

        if (pvdSelectedRow != null) {
            pedidosViandasDetalle.splice(pvdSelectedRow, 1);
            settingsPedidosViandasDetalle.splice(pvdSelectedRow, 1);

            this.setState({
                pedidosViandasDetalle: pedidosViandasDetalle,
                settingsPedidosViandasDetalle: settingsPedidosViandasDetalle,
                pvdSelectedRow: null,
            });
        }
    };

    /* ---------- FUNC. EDITAR DETALLE ---------- */
    editarDetalle = () => {
        const {
            ar_entradas,
            ar_menusPrincipales,
            ar_guarniciones,
            ar_ensaladas,
            ar_complementos,
            ar_postres,
            ar_bebidas,
        } = this.state;

        let pedidosViandasDetalle = [...this.state.pedidosViandasDetalle];
        let settingsPedidosViandasDetalle = [...this.state.settingsPedidosViandasDetalle];
        let pvdSelectedRow = this.state.pvdSelectedRow;

        let pedidoSeleccionado = pedidosViandasDetalle[pvdSelectedRow];
        let settingsPedidoSeleccionado = settingsPedidosViandasDetalle[pvdSelectedRow];

        const hayPersonaSeleccionada = pvdSelectedRow != null;
        const hayComplementosSeleccionados = pedidoSeleccionado.complementos.length > 0;
        const hayEnsaladasSeleccionadas = pedidoSeleccionado.ensaladas.length > 0;

        if (hayPersonaSeleccionada) {
            // Se checkean todos los elementos previamente checkeados en el pedido seleccionado
            this.setState({ 
                // Se saca el pedido seleccionado de la lista preconfirmada
                pedidosViandasDetalle: pedidosViandasDetalle.filter((_, index) => index !== pvdSelectedRow),
                // Se sacan las settings del pedido seleccionado de la lista preconfirmada
                settingsPedidosViandasDetalle: settingsPedidosViandasDetalle.filter((_, index) => index !== pvdSelectedRow),
                pvdSelectedRow: null,
                ar_entradas: ar_entradas.map(entrada => ({
                    ...entrada, checked: entrada.id === pedidoSeleccionado.entrada
                })),
                ar_menusPrincipales: ar_menusPrincipales.map(menuPrincipal => ({
                    ...menuPrincipal, checked: menuPrincipal.id === pedidoSeleccionado.menu_principal
                })),
                ar_guarniciones: ar_guarniciones.map(guarnicion => ({
                    ...guarnicion, checked: guarnicion.id === pedidoSeleccionado.guarnicion
                })),
                ar_ensaladas: ar_ensaladas.map(ensalada => ({
                    ...ensalada,
                    checked: hayEnsaladasSeleccionadas ?
                        pedidoSeleccionado.ensaladas.includes(ensalada.id) :
                        // Si el array está vacío entonces se que checkea la opcion "Nada"
                        ensalada.id === this.OPCION_NADA_ID
                })),
                ar_complementos: ar_complementos.map(complemento => ({
                    ...complemento,
                    checked: hayComplementosSeleccionados ? 
                        pedidoSeleccionado.complementos.includes(complemento.id) :
                        // Si el array está vacío entonces se que checkea la opcion "Nada"
                        complemento.id === this.OPCION_NADA_ID
                })),
                ar_postres: ar_postres.map(postre => ({
                    ...postre, checked: postre.id === pedidoSeleccionado.postre
                })),
                ar_bebidas: ar_bebidas.map(bebida => ({
                    ...bebida, checked: bebida.id === pedidoSeleccionado.bebida
                })),
                ensaladaComoMenuPrincipal: settingsPedidoSeleccionado.ensaladaComoMenuPrincipal,
                persona_id: pedidoSeleccionado.persona,
                centroCosto: pedidoSeleccionado.dependencia,
                apellido: pedidoSeleccionado.apellido,
            });
        }
    };

    handleNoAdjuntarClick = (codigo_verificacion) => {
        this.setState({
            msjModal:
                <h4 className={"text-center"}>
                    <p>El pedido fué generado correctamente 🎉</p>
                    <p>Tu código de verificación es:</p>
                    <p><strong>{codigo_verificacion}</strong></p>
                </h4>,
        });
    }

    // Se guarda el pedido realizado
    onSubmit = () => {
        const {
            pedidosViandasDetalle,
            fecha,
            planta_id,
            menudiario_id,
            lugarEntrega,
            observacion,
            lugar_entrega_otros,
        } = this.state;

        if (this.onValidation()) {
            let data = {
                pedidos_viandas_detalle: pedidosViandasDetalle,
                fecha,
                observacion,
                // Si se eligió especificar un lugar de entrega libre (lugar_entrega_otros) el lugar de entrega (lugarEntrega) tiene que ser null
                area: lugarEntrega === this.OPCION_LUGAR_ENTREGA_OTROS_ID ? null : lugarEntrega,
                otros_lugar_de_entrega: lugar_entrega_otros,
                planta: planta_id,
                menu_diario: menudiario_id,
            };

            apiFunctions.post(
                api.viandas.misPedidos,
                null,
                data,
                (response) => {
                    let codigo_verificacion = response.data.codigo_verificacion;

                    // Lo unico que se puede adjuntar a una vianda es un pedido de
                    // insumos. Si el usuario no puede crearlos, no se le ofrece:
                    // el pedido de vianda ya quedo hecho, asi que va directo al
                    // mensaje con el codigo de verificacion (lo mismo que el "No").
                    if (!this.puedePedirInsumos()) {
                        this.setState({ isOpenModal: true });
                        this.handleNoAdjuntarClick(codigo_verificacion);
                        this.resetForm();
                        this.cargarDatosDelUsuario();
                        return;
                    }

                    this.setState({
                        isOpenModal: true,
                        msjModal:
                            <div className={"text-center"}>
                                <h4>¿Adjuntar un Pedido de Insumos?</h4>
                                <div className="flex justify-center gap-4 mt-6">
                                    <Button
                                        color="secondary"
                                        className="rounded btn-info yes-no-buttons mr-4"
                                        onClick={() => this.redirectToPedidoInsumo(codigo_verificacion)}
                                    >
                                        <h4>Si</h4>
                                    </Button>
                                    <Button
                                        color="secondary"
                                        className="rounded yes-no-buttons"
                                        onClick={() => this.handleNoAdjuntarClick(codigo_verificacion)}
                                    >
                                        <h4>No</h4>
                                    </Button>
                                </div>
                            </div>,
                    });
                    this.resetForm();
                    this.cargarDatosDelUsuario();
                },
                (response) => {
                    if (response.errors) {
                        this.setErrors(response.errors);
                    }
                }
            );
        }
    };

    changeIsOpenModal = () => {
        const { isOpenModal } = this.state;
        this.setState({ isOpenModal: !isOpenModal });
    };

    // El permiso es el mismo que pide el backend en viandas/pedidos/adjuntable/ y
    // en el POST de pedidos/mis/insumos/, los dos pasos de la adjuncion.
    puedePedirInsumos = () => auth.hasPermission('cliente_productos_pedidos_insumos_new');

    redirectToPedidoInsumo = (codigo_verificacion) => {
        const codigoVerificacion = codigo_verificacion || "";

        this.props.history.push('/pedidosinsumos/adjuntar/pedidovianda/' + codigoVerificacion);
    };

    toggleEnsaladaComoMenuPrincipal = () => {
        const { 
            ensaladaComoMenuPrincipal,
            ar_menusPrincipales,
            ar_guarniciones,
            ar_ensaladas,
        } = this.state;

        this.setState({ 
            ensaladaComoMenuPrincipal: !ensaladaComoMenuPrincipal 
        }, () => {
            // isMenuPrincipalVisible usa ensaladaComoMenuPrincipal, como 
            // setState es async hay que esperar a que se realize este cambio
            if (this.isMenuPrincipalVisible()) {
                // Al reaparecer el menu principal se lo deja todo unchecked
                this.setState({
                    ar_menusPrincipales: ar_menusPrincipales.map(menuPrincipal => ({ ...menuPrincipal, checked: false })),
                    ar_guarniciones: ar_guarniciones.map(guarnicion => ({ ...guarnicion, checked: false })),
                    ar_ensaladas: ar_ensaladas.map(ensalada => ({ ...ensalada, checked: false })),
                });
            } else {
                // Al esconderse el menú principal, se eligen las opciones 'Nada'
                this.setState({
                    ar_menusPrincipales: ar_menusPrincipales.map(menuPrincipal => ({
                            ...menuPrincipal, checked: menuPrincipal.id === this.OPCION_NADA_ID
                    })),
                    ar_guarniciones: ar_guarniciones.map(guarnicion => ({
                            ...guarnicion, checked: guarnicion.id === this.OPCION_NADA_ID
                    })),
                })
            }
        });
    };

    isMenuPrincipalVisible(){
        const { ensaladaComoMenuPrincipal } = this.state;
        return !ensaladaComoMenuPrincipal;
    };

    /**
     * Cuando la planta galvan se selecciona hay que desactivar el input de lugar de entrega ya que solo puede tener un valor y es "Posta de inflamables"
     * @returns - True si se selecciona Planta Galvan
     */
    isLugarDeEntregaInputDisabled(){
        const { planta_id } = this.state;
        return this.isPlantaGalvanSelected(planta_id)
    };

    handlePlantaChange = (data) => {
        const { lugaresEntregaSelect } = this.state

        this.setState({ planta_id: data ? data.id : null });

        // Cuando esté seleccionado planta galvan hay que seleccionar el lugar de entrega como "Posta de inflamables"
        if (this.isPlantaGalvanSelected(data.id)) {
            const postaInflamablesNombre = "posta inflamables";
            const lugarEntregaPostaInflamables = lugaresEntregaSelect.find(lugarEntrega => lugarEntrega.nombre.toLowerCase() == postaInflamablesNombre)
            this.setState({
                lugarEntrega: lugarEntregaPostaInflamables.id,
                lugar_entrega_otros: null // En caso de que se haya seleccionado planta galvan despues de haber puesto algun otro lugar de entrega especifico
            })
        }
    };

    isPlantaGalvanSelected(plantaId){
        const { plantasSelect } = this.state;
        const selectedPlanta = plantasSelect ? plantasSelect.find(planta => planta.id === plantaId) : null;
        const plantaGalvanSelected = selectedPlanta ? selectedPlanta.nombre.toLowerCase() == "galvan" : null;

        return plantaGalvanSelected ? true : false
    };

    handleLugarEntregaChange = (data) => {
        this.setState({ 
            lugarEntrega: data ? data.id : null,
            lugar_entrega_otros: null 
        });
    }
    
    handleMenuDiarioChange = (data) => {
        this.onChangeField("menudiario_id", data ? data.id : null);
        this.cargarMenues(data);
        // Para que no quede una Persona seleccionada que no puede pedir este
        // Menú denuevo.
        this.setState({ 
            personasSelect: [],
            persona_id: null,
        });

        // Se cargar las Personas que pueden pedir este menú
        getPersonasData(data.id).then((personasData) => {
            this.setState({ personasSelect: personasData });
        });
    }


    handlePersonaChange = (data_persona) => {
        this.setState({
            persona_id: data_persona ? data_persona.id : null,
            apellido: data_persona ? data_persona.apellido + ", " + data_persona.nombre : "",
            centroCosto: data_persona ? data_persona.dependencia_id : null,
        })
    }

    handleCentroCostoChange = (data) => {
        this.setState({
            centroCosto: data ? data.id : null,
        })
    }

    isOpcionNadaSelected = (arrayItems) => {
        return arrayItems.some(opcion => opcion.id === this.OPCION_NADA_ID && opcion.checked);
    }

    render() {
        const {
            user_nombre,
            user_apellido,

            plantasSelect,
            planta_id,

            lugaresEntregaSelect,
            lugarEntrega,
            lugar_entrega_otros,

            menudiario_id,
            pedidosViandasDetalle,
            pvdSelectedRow,
            ar_entradas,
            ar_menusPrincipales,
            ar_guarniciones,
            ar_ensaladas,
            ar_complementos,
            ar_postres,
            ar_bebidas,

            personasSelect,
            persona_id,
            centrosCostoSelect,
            centroCosto,

            loading,
            disabled,
            isOpenModal,
            msjModal,
            ensaladaComoMenuPrincipal,
            observacion,
        } = this.state;

        const seleccionarAlMenosUnaOpcionDistintaDeNada =
            this.isOpcionNadaSelected(ar_entradas) &&
            this.isOpcionNadaSelected(ar_menusPrincipales) &&
            this.isOpcionNadaSelected(ar_guarniciones) &&
            this.isOpcionNadaSelected(ar_ensaladas) &&
            this.isOpcionNadaSelected(ar_complementos) &&
            this.isOpcionNadaSelected(ar_postres) &&
            this.isOpcionNadaSelected(ar_bebidas);

        const faltaCompletarCamposPrincipales = [
            planta_id === null && ' Planta',
            lugarEntrega === null && ' Lugar de entrega',
            lugarEntrega === this.OPCION_LUGAR_ENTREGA_OTROS_ID && (lugar_entrega_otros === null || lugar_entrega_otros.trim() === "") && ' Especificar Lugar de entrega',
            menudiario_id === null && ' Menú Diario',
        ].filter(Boolean);

        const faltanCompletarParaCargarPersona = [
            persona_id == null && ' Persona',
            centroCosto === null && ' Centro de Costo',
            ar_entradas.every(entrada => !entrada.checked) && ' Entrada',
            ar_menusPrincipales.every(menuPrincipal => !menuPrincipal.checked) && ' Menú Principal',
            ar_guarniciones.every(guarnicion => !guarnicion.checked) && ' Guarnicion',
            ar_ensaladas.every(ensalada => !ensalada.checked) && ' Ensaladas',
            ar_complementos.every(complemento => !complemento.checked) && ' Complementos',
            ar_postres.every(postre => !postre.checked) && ' Postre',
            ar_bebidas.every(bebida => !bebida.checked) && ' Bebida',
            seleccionarAlMenosUnaOpcionDistintaDeNada && 'Al menos una opción distinta de "Nada"',
        ].filter(Boolean);

        let errorPersonas = this.getError("pedidos_viandas_detalle")
        errorPersonas = errorPersonas ? errorPersonas[0].detail : null

        const personasIdYaElegidas = pedidosViandasDetalle.map(detalle => detalle.persona);
        const personasSelectFiltrado = personasSelect.filter(
            persona => !personasIdYaElegidas.includes(persona.id)
        );

        return (
            <div
                className={"mt-2"}
                style={{ maxHeight: "90vh" }}
            >
                {Boolean(loading) && (
                    <div className="full-page-loader">
                        <BounceLoader />
                        <div className="mt-2" style={{ fontSize: "1.5rem" }}>
                            {loading || "Cargando..."}
                        </div>
                    </div>
                )}
                <Container className="p-2 px-md-5 position-relative contFormViandas" >
                    <Row>
                        <Col
                            xs={12}
                            lg={8}
                            className="d-flex align-items-center flex-wrap"
                        >
                            <h1
                                className="d-inline-block display-4 mb-0"
                                style={{ fontSize: "3rem" }}
                            >
                                <i className="fa fa-cutlery me-2 mr-2" style={{ color: '#32CD32' }}></i>
                                {'Nuevo Pedido de Vianda'}
                            </h1>
                        </Col>
                    </Row>

                    <Row className={"mt-4"}>
                        <Col className={"col-6"}>
                            <ParadigmaLabeledInput
                                disabled={true}
                                className="mr-2"
                                md={[3, 9]}
                                maxLength={100}
                                label={"Responsable"}
                                value={user_nombre + ' ' + user_apellido}
                            />
                        </Col>
                        {/* Btn Ayuda Responsable */}
                        <Col className="col-1 d-flex align-items-center">
                            <Button
                                id="userResponsable"
                                size="sm"
                                color="warning"
                                className="rounded"
                            >
                                <i className="fa fa-question" />
                            </Button>
                        </Col>

                        {/* Tooltip Ayuda */}
                        <UncontrolledTooltip
                            className="rounded-tooltip"
                            placement="right"
                            target="userResponsable"
                        >
                            El Responsable del pedido siempre es el usuario actual
                        </UncontrolledTooltip>
                    </Row>

                    <Row className={"mt-3"}>
                        <Col className={"col-6"}>
                            <ParadigmaLabeledInput
                                md={[3, 9]}
                                label={"Planta"}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        optionDefault={plantasSelect}
                                        clearable={false}
                                        value={planta_id}
                                        onChange={this.handlePlantaChange}
                                    />
                                }
                                error={() => this.getError("planta_id")}
                            />
                        </Col>

                        <Col className={"col-6"}>
                            <ParadigmaLabeledInput
                                md={[4, 8]}
                                label={"Lugar de entrega"}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        optionDefault={lugaresEntregaSelect}
                                        value={lugarEntrega}
                                        disabled={this.isLugarDeEntregaInputDisabled()}
                                        onChange={(data) => this.handleLugarEntregaChange(data)}
                                    />
                                }
                                error={() => this.getError("area_id")}
                            />
                        </Col>
                    </Row>

                    {lugarEntrega === this.OPCION_LUGAR_ENTREGA_OTROS_ID && (
                        <Row className={"mt-3"}>
                            <React.Fragment>
                                <Col className={"col-6"}/>
                                {/* Input Lugar de entrega Especifica */}
                                <Col className={"col-6"}>
                                    <ParadigmaLabeledInput
                                        md={[4, 8]}
                                        label={"Especificar"}
                                        maxLength={100}
                                        value={lugar_entrega_otros}
                                        onChange={(e) => { this.setState({ lugar_entrega_otros: e.target.value }) }}
                                    />
                                </Col>
                            </React.Fragment>
                        </Row>
                    )}

                    <Row className={"mt-3"}>
                        <Col className={"col-6"}>
                            <ParadigmaLabeledInput
                                md={[3, 9]}
                                label={"Menú Diario"}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        autoselect={true}
                                        disabled={disabled}
                                        url={api.viandas.menudiarioHoy}
                                        displayField={"codigo"}
                                        value={menudiario_id}
                                        parameters={{ pageSize: 100 }}
                                        onChange={this.handleMenuDiarioChange}
                                    />
                                }
                                error={() => this.getError("menudiario_id")}
                            />
                        </Col>
                    </Row>

                    { /* ---------- Mensaje Falta Opcion ---------- */}
                    {faltaCompletarCamposPrincipales.length > 0 &&
                        <h5 className="faltanOpciones">
                            {'⬆ Faltan completar los campos correspondientes:'}
                            <ul className="list-unstyled text-center mb-0">
                                {faltaCompletarCamposPrincipales.map(campoFaltante =>
                                    <li key={campoFaltante}>- {campoFaltante}</li>
                                )}
                            </ul>
                        </h5>
                    }

                    {faltaCompletarCamposPrincipales.length == 0 && (
                        <div>
                            <Row className={"mt-3"}>
                                <Col className={"col-12"}>
                                    <Row>
                                        <Col className={"col-6"}>
                                            <ParadigmaLabeledInput
                                                md={[3, 9]}
                                                error={() => this.getError("persona_id")}
                                                label={"Personas"}
                                                inputComponent={
                                                    <Row>
                                                        <Col className={"col-9"}>
                                                            <ParadigmaAsyncSeeker
                                                                optionDefault={personasSelectFiltrado}
                                                                disabled={disabled}
                                                                value={persona_id}
                                                                displayField={"apellido_nombre"}
                                                                onChange={data => this.handlePersonaChange(data)}
                                                            />
                                                        </Col>
                                                    </Row>
                                                }
                                            />
                                        </Col>

                                        <Col className={"col-6"}>
                                            <ParadigmaLabeledInput
                                                md={[4, 8]}
                                                label={"Centro de Costo"}
                                                inputComponent={
                                                    <ParadigmaAsyncSeeker
                                                        optionDefault={centrosCostoSelect}
                                                        value={centroCosto}
                                                        displayField={'codigo'}
                                                        onChange={data => this.handleCentroCostoChange(data)}
                                                    />
                                                }
                                                error={() => this.getError("dependencia")}
                                            />
                                        </Col>
                                    </Row>
                                </Col>

                                {/* ---------- Entrada ---------- */}
                                <Col className={"col-12 mt-2 py-3 px-3"}>
                                    <h5>Entrada</h5>
                                    <Table size="sm" className="mt-2 t_clientes table-hover">
                                        <thead>
                                            <tr>
                                                <th>N°</th>
                                                <th>Codigo</th>
                                                <th>Nombre</th>
                                                <th style={{ textAlign: 'right' }}>Selección</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ar_entradas.map((data, i) => (
                                                <tr
                                                    key={i}
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => this.checkEntradas(i)}
                                                >
                                                    <td>{i + 1}</td>
                                                    <td>{data.codigo}</td>
                                                    <td>{data.nombre}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <input
                                                            type="checkbox"
                                                            className="checkbox-Menues"
                                                            checked={data.checked}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                            {ar_entradas.length === 0 && (
                                                <tr>
                                                    <td
                                                        className="text-center"
                                                        colSpan={3}
                                                    >
                                                        No hay Entradas agregadas
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>

                                {/* ---------- Menú Principal ---------- */}
                                {!this.isMenuPrincipalVisible() && (
                                    <Col className={"col-6 mt-2 py-3 px-3"}></Col>
                                )}

                                {this.isMenuPrincipalVisible() && (
                                    <Col className={"col-6 mt-2 py-3 px-3"}>
                                        <h5>Menú Principal</h5>
                                        <Table size="sm" className="mt-2 t_clientes table-hover">
                                            <thead>
                                                <tr>
                                                    <th>N°</th>
                                                    <th>Codigo</th>
                                                    <th>Nombre</th>
                                                    <th style={{ textAlign: 'right' }}>Selección</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {ar_menusPrincipales.map((data, i) => (
                                                    <tr
                                                        key={i}
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => this.checkMenuPrincipal(i)}
                                                    >
                                                        <td>{i + 1}</td>
                                                        <td>{data.codigo}</td>
                                                        <td>{data.nombre}</td>
                                                        <td style={{ textAlign: 'right' }}>
                                                            <input
                                                                type="checkbox"
                                                                className="checkbox-Menues"
                                                                checked={data.checked}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                                {ar_menusPrincipales.length === 0 && (
                                                    <tr>
                                                        <td
                                                            className="text-center"
                                                            colSpan={3}
                                                        >
                                                            No hay Menús Principales agregados
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </Col>
                                )}                                            

                                {/* ---------- Guarnición ---------- */}
                                {!this.isMenuPrincipalVisible() && (
                                    <Col className={"col-6 mt-2 py-3 px-3"}></Col>
                                )}

                                {this.isMenuPrincipalVisible() && (
                                    <Col className={"col-6 mt-2 py-3 px-3"}>
                                        <h5>Guarnición</h5>
                                        <Table size="sm" className="mt-2 t_clientes table-hover">
                                            <thead>
                                                <tr>
                                                    <th>N°</th>
                                                    <th>Codigo</th>
                                                    <th>Nombre</th>
                                                    <th style={{ textAlign: 'right' }}>Selección</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {ar_guarniciones.map((data, i) => (
                                                    <tr
                                                        key={i}
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => this.checkGuarnicion(i)}
                                                    >
                                                        <td>{i + 1}</td>
                                                        <td>{data.codigo}</td>
                                                        <td>{data.nombre}</td>
                                                        <td style={{ textAlign: 'right' }}>
                                                            <input
                                                                type="checkbox"
                                                                className="checkbox-Menues"
                                                                checked={data.checked}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                                {ar_guarniciones.length === 0 && (
                                                    <tr>
                                                        <td
                                                            className="text-center"
                                                            colSpan={3}
                                                        >
                                                            No hay Guarniciones agregadas
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </Col>
                                )}                                            

                                {/* ---------- ENSALADAS ---------- */}
                                <Col className="col-6 mt-2 py-3 px-3">
                                    <div className="d-flex align-items-center ensalada-titlebar-container">
                                        <h5 className="padding-ensalada">Ensalada/s</h5>
                                        <input
                                            type="checkbox"
                                            className="checkbox-Menues mr-2 ensalada-checkbox"
                                            checked={ensaladaComoMenuPrincipal}
                                            onChange={this.toggleEnsaladaComoMenuPrincipal}
                                        />
                                        <h5
                                            className={`cursor-pointer ${ensaladaComoMenuPrincipal ? '' : 'ensalada-menu-principal-unchecked'}`}
                                            onClick={this.toggleEnsaladaComoMenuPrincipal}
                                        >
                                            Como Menú Principal
                                        </h5>

                                        <Button
                                            id="ensaladaComoMenuPrincipal"
                                            color="warning"
                                            className="rounded ensalada-tooltip"
                                        >
                                            <i className="fa fa-question" />
                                        </Button>
                                        <UncontrolledTooltip
                                            className="rounded-tooltip"
                                            placement="right"
                                            target="ensaladaComoMenuPrincipal"
                                        >
                                            Permite elegir 4 ensaladas, no se puede elegir menú principal ni guarnicion.
                                        </UncontrolledTooltip>
                                    </div>
                                    <Table size="sm" className="mt-2 t_clientes table-hover">
                                        <thead>
                                            <tr>
                                                <th>N°</th>
                                                <th>Codigo</th>
                                                <th>Nombre</th>
                                                <th style={{ textAlign: 'right' }}>Selección</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ar_ensaladas.map((data, i) => (
                                                <tr
                                                    key={i}
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => this.checkEnsalada(i)}
                                                >
                                                    <td>{i + 1}</td>
                                                    <td>{data.codigo}</td>
                                                    <td>{data.nombre}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <input
                                                            type="checkbox"
                                                            className="checkbox-Menues"
                                                            checked={data.checked}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                            {ar_ensaladas.length === 0 && (
                                                <tr>
                                                    <td
                                                        className="text-center"
                                                        colSpan={3}
                                                    >
                                                        No hay Ensaladas agregadas
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>

                                {/* ---------- COMPLEMENTOS ---------- */}
                                <Col className={"col-6 mt-2 py-3 px-3"}>
                                    <h5>
                                        Complemento/s

                                        {/* Btn Select All */}
                                        <Button
                                            className={"btn_cselectall"}
                                            id={"cselectall"}
                                            size="sm"
                                            // Se seleccionan todos los complementos excepto la opcion "Nada"
                                            onClick={() => this.setState({ ar_complementos: ar_complementos.map(complemento => ({ ...complemento, checked: complemento.id !== this.OPCION_NADA_ID })) })}
                                        >
                                            <i className="fa fa-check-square-o" />
                                        </Button>

                                        <UncontrolledTooltip
                                            className="rounded-tooltip"
                                            placement="bottom"
                                            target="cselectall"
                                        >
                                            Seleccionar todos
                                        </UncontrolledTooltip>

                                        {/* Btn Unselect All */}
                                        <Button
                                            className={"btn_uncselectall mr-1"}
                                            id={"uncselectall"}
                                            size="sm"
                                            onClick={() => this.setState({ ar_complementos: ar_complementos.map(complemento => ({ ...complemento, checked: false })) })}
                                        >
                                            <i className="fa fa-minus-square-o" />
                                        </Button>

                                        <UncontrolledTooltip
                                            className="rounded-tooltip"
                                            placement="bottom"
                                            target="uncselectall"
                                        >
                                            Deseleccionar todos
                                        </UncontrolledTooltip>
                                    </h5>

                                    <Table size="sm" className="mt-2 t_clientes table-hover">
                                        <thead>
                                            <tr>
                                                <th>N°</th>
                                                <th>Codigo</th>
                                                <th>Nombre</th>
                                                <th style={{ textAlign: 'right' }}>Selección</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ar_complementos.map((data, i) => (
                                                <tr
                                                    key={i}
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => this.checkComplemento(i)}
                                                >
                                                    <td>{i + 1}</td>
                                                    <td>{data.codigo}</td>
                                                    <td>{data.nombre}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <input
                                                            type="checkbox"
                                                            className="checkbox-Menues"
                                                            checked={data.checked}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                            {ar_complementos.length === 0 && (
                                                <tr>
                                                    <td
                                                        className="text-center"
                                                        colSpan={3}
                                                    >
                                                        No hay complementos agregados
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>

                                {/* ---------- POSTRES ---------- */}
                                <Col className={"col-6 mt-2 py-3 px-3"}>
                                    <h5>Postre</h5>
                                    <Table size="sm" className="mt-2 t_clientes table-hover">
                                        <thead>
                                            <tr>
                                                <th>N°</th>
                                                <th>Codigo</th>
                                                <th>Nombre</th>
                                                <th style={{ textAlign: 'right' }}>Selección</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ar_postres.map((data, i) => (
                                                <tr
                                                    key={i}
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => this.checkPostre(i)}
                                                >
                                                    <td>{i + 1}</td>
                                                    <td>{data.codigo}</td>
                                                    <td>{data.nombre}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <input
                                                            type="checkbox"
                                                            className="checkbox-Menues"
                                                            checked={data.checked}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                            {ar_postres.length === 0 && (
                                                <tr>
                                                    <td
                                                        className="text-center"
                                                        colSpan={3}
                                                    >
                                                        No hay Postres agregados
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>

                                {/* ---------- BEBIDAS ---------- */}
                                <Col className={"col-6 mt-2 py-3 px-3"}>
                                    <h5>Bebida</h5>
                                    <Table size="sm" className="mt-2 t_clientes table-hover">
                                        <thead>
                                            <tr>
                                                <th>N°</th>
                                                <th>Codigo</th>
                                                <th>Nombre</th>
                                                <th style={{ textAlign: 'right' }}>Selección</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ar_bebidas.map((data, i) => (
                                                <tr
                                                    key={i}
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => this.checkBebidas(i)}
                                                >
                                                    <td>{i + 1}</td>
                                                    <td>{data.codigo}</td>
                                                    <td>{data.nombre}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <input
                                                            type="checkbox"
                                                            className="checkbox-Menues"
                                                            checked={data.checked}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                            {ar_bebidas.length === 0 && (
                                                <tr>
                                                    <td
                                                        className="text-center"
                                                        colSpan={3}
                                                    >
                                                        No hay Bebidas agregadas
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>

                                <Col className={"col-6 mt-2 py-3 px-3"}>
                                    <h5>👤 Detalle del Pedido por Persona</h5>
                                    <Row>
                                        {/* BTN DETALLE PEDIDO */}
                                        <Col className={"col-4 pr-1"}>
                                            <Button
                                                block
                                                id="pedidoToolTip"
                                                color="success"
                                                className="rounded"
                                                disabled={faltanCompletarParaCargarPersona.length > 0}
                                                onClick={() => this.agregarDetalle()}
                                                style={{ cursor: faltanCompletarParaCargarPersona.length > 0 ? 'not-allowed' : 'pointer' }}
                                            >
                                                <i className="fa fa-plus mr-1"></i>
                                                Cargar Persona
                                            </Button>

                                            {/* Tooltip Btn Detalle Pedido */}
                                            { faltanCompletarParaCargarPersona.length > 0 && (
                                                    <UncontrolledTooltip
                                                        className="rounded-tooltip"
                                                        placement="right"
                                                        target="pedidoToolTip"
                                                    >
                                                        Falta seleccionar:
                                                        <ul className="list-unstyled text-left mb-0">
                                                        {faltanCompletarParaCargarPersona.map(campoFaltante =>
                                                            <li key={campoFaltante}>- {campoFaltante}</li>
                                                        )}
                                                        </ul>
                                                    </UncontrolledTooltip>
                                                )}
                                        </Col>

                                        {/* BTN EDITAR PERSONA */}
                                        <Col className={"col-4 px-1"}>
                                            <Button
                                                block
                                                color="success"
                                                className="rounded"
                                                disabled={pvdSelectedRow == null}
                                                onClick={() => {
                                                    pvdSelectedRow != null
                                                        ? this.editarDetalle()
                                                        : null;
                                                }}
                                                style={{ cursor: pvdSelectedRow == null ? 'not-allowed' : 'pointer' }}
                                            >
                                                <i className="fa fa-pencil mr-1"></i>
                                                Editar Persona
                                            </Button>
                                        </Col>

                                        {/* BTN ELIMINAR PEDIDO */}
                                        <Col className={"col-4 pl-1"}>
                                            <Button
                                                block
                                                disabled={pvdSelectedRow == null}
                                                color="danger"
                                                className="rounded"
                                                onClick={() => {
                                                    pvdSelectedRow != null
                                                        ? this.eliminarDetalle()
                                                        : null;
                                                }}
                                                style={{ cursor: pvdSelectedRow == null ? 'not-allowed' : 'pointer' }}
                                            >
                                                <i className="fa fa-trash mr-1"></i>
                                                Eliminar Persona
                                            </Button>
                                        </Col>
                                    </Row>

                                    <Table size="sm" className="mt-2 t_clientes">
                                        <thead>
                                            <tr>
                                                <th>N°</th>
                                                <th>Persona</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pedidosViandasDetalle.map(
                                                (data, i) => (
                                                    <tr
                                                        key={i}
                                                        onClick={() => this.setState((prevState) => ({ pvdSelectedRow: prevState.pvdSelectedRow === i ? null : i }))}
                                                        style={{
                                                            cursor: "pointer",
                                                            background: pvdSelectedRow === i ? "rgba(0,0,0,0.1)" : "none",
                                                        }}
                                                    >
                                                        <td>{i + 1}</td>
                                                        <td>{data.apellido}</td>
                                                    </tr>
                                                )
                                            )}
                                            {pedidosViandasDetalle.length === 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={3}>
                                                        <div className="my-4">No hay pedidos agregados</div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>

                                    {errorPersonas && (
                                        <Alert color={"danger"}>
                                            {errorPersonas}
                                        </Alert>
                                    )}
                                    {this.getError("pedidosViandasDetalle") && (
                                        <Alert
                                            color={"danger"}
                                            className={"text-center"}
                                        >
                                            {this.getError("pedidosViandasDetalle")[0]["detail"]}
                                        </Alert>
                                    )}
                                </Col>
                            </Row>

                            { /* ---------- FOOTER ---------- */}
                            <Row>
                                <Col xs={12}>
                                    <ButtonToolbar className="my-3">
                                        <Button
                                            tag={Link}
                                            to="/tickets"
                                            outline
                                            className="mr-auto rounded"
                                        >
                                            <i className="fa fa-long-arrow-left mr-2"></i>
                                            Volver
                                        </Button>

                                        {
                                            // Boton para confirmar el pedido
                                            // Usa pedidosViandasDetalle que tiene toda la data para ser usada en la api
                                            // Se usa el pedidosViandasDetalle en el onSubmit
                                            !disabled && (
                                                <ModalConfirmacion
                                                    disabled={
                                                        menudiario_id == null ||
                                                        planta_id == null ||
                                                        lugarEntrega == null
                                                    }
                                                    onSubmit={() => { this.onSubmit() }}
                                                    title={
                                                        <span>
                                                            Confirmación del Pedido
                                                        </span>
                                                    }
                                                    opcionNadaId={this.OPCION_NADA_ID}
                                                    pedidosViandasDetalle={pedidosViandasDetalle}
                                                    lugarEntrega={lugarEntrega}
                                                    lugaresEntregaSelect={lugaresEntregaSelect}
                                                    lugar_entrega_otros={lugar_entrega_otros}
                                                    centrosCostoSelect={centrosCostoSelect}
                                                    ar_entradas={ar_entradas}
                                                    ar_menusPrincipales={ar_menusPrincipales}
                                                    ar_guarniciones={ar_guarniciones}
                                                    ar_ensaladas={ar_ensaladas}
                                                    ar_complementos={ar_complementos}
                                                    ar_postres={ar_postres}
                                                    ar_bebidas={ar_bebidas}
                                                    observacion={observacion}
                                                    onChangeObservacion={(d) => { this.setState({ observacion: d.target.value }); }}
                                                    onValidation={this.onValidation}
                                                />
                                            )
                                        }
                                    </ButtonToolbar>
                                </Col>
                            </Row>
                        </div>
                    )}

                    <Modal
                        isOpen={isOpenModal}
                        toggle={() => this.changeIsOpenModal()}
                        className={"modal-primary"}
                    >
                        <ModalHeader className={""}>
                            Pedido de Vianda
                        </ModalHeader>
                        <ModalBody>
                            {msjModal}
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="secondary"
                                className="rounded"
                                onClick={() => this.changeIsOpenModal()}
                            >
                                Volver
                            </Button>
                        </ModalFooter>
                    </Modal>
                </Container>
            </div>
        );
    }
}

export default FormViandas;



// WEBPACK FOOTER //
// ./src/views/Viandas/PedidosViandas/FormViandas.js